var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"event-list-entry"},[_c('h4',{staticClass:"entry-title"},[_vm._v(_vm._s(_vm.item.$.title))]),_c('p',{staticClass:"entry-teaser"},[_vm._v(_vm._s(_setup.stripHtml(_vm.item.$.summary_text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }